export default __webpack_public_path__ + "static/media/talent-main-section-buy-project-by-Dev-IT.fadb2d53.png";